export const setCookie = (cname: string, cvalue: string, exdays: number = 365) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

export const getCookie = (cname: string) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const getAllCookies = (): { [key: string]: string } => document.cookie.split(';').reduce((cookies, cookie) => {
    const splitted = cookie.split('=');
    return {
        ...cookies,
        [(splitted[0] || '').trim()]: splitted[1] || ''
    };
}, {});

export const removeCookie = (cname: string) => {
    const expires = `expires=${new Date(1)}`;
    document.cookie = `${cname}=;${expires};path=/`;
};